export const ALLERGIES = {
  key: 'ALLERGIES',
  group: 4,
  value: 8,
  title: 'health-record.allergies.title',
  menu_title: 'health-record.allergies.title',
  sub_title: 'health-record.allergies.allergies-title-example',
  imageURL: require('@assets/images/Health-Record-Icons/Icon-Allergies.svg'),
  list_title: 'Allergy',
  icon: 'flower',
  editor: 'AllergyEditor',
  message_translate: 'health-record.allergies.message',
  model_name: 'allergy',
  resource: 'hr/allergy/',
  plain_resource: 'allergy',
  id: 'hr_id',
  headers: [
    {
      text: 'health-record.allergies.allergy',
      value: 'record.allergy',
    },
    {
      text: 'category',
      value: 'record.category.value',
    },
    {
      text: 'health-record.allergies.start-date',
      value: 'record.start_formatted',
    },
    {
      text: 'health-record.actions',
      value: 'actions',
      sortable: false,
      width: '100px',
    },
  ],
  sortables: {
    record: {
      start_formatted: 'start',
      last_occurrence_formatted: 'last_occurrence',
      category: {
        value: 'category',
      },
      allergy: 'allergy',
      type: {
        value: 'type',
      },
      criticality: {
        value: 'criticality',
      },
      reaction: {
        value: 'reaction',
      },
      verification_status: {
        value: 'verification_status',
      },
    },
  },
  show_menu: true,
  background: 'linear-gradient(122.25deg, #00796B 3.07%, #4DB6AC 100%)',
  color: '#3BAFA4',
  opaque: '#D4EBE9',
}
